var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxcontent-item",on:{"click":function($event){return _vm.$emit('select', _vm.category.id)}}},[_c('i',{staticClass:"far fa-folder-open"}),_c('p',{staticClass:"boxcontent-item-title"},[_vm._v(_vm._s(_vm.category.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }